<form *ngIf="form" class="flex flex-col items-center gap-5" [formGroup]="form">
  <ng-container [formArrayName]="FormControlName.lifeChanges">
    <ng-container *ngFor="let block of formArrayLifeChanges.controls; let index = index">
      <pl-life-change class="w-full" [formControlName]="index + ''" (deleteLifeChange)="deleteLifeChange(index)" />
    </ng-container>
  </ng-container>
  <pl-button
    *ngIf="showAddLifeChangeButton"
    class="!w-fit"
    [variant]="ButtonVariant.lightOrange"
    (click)="addLifeChange()"
  >
    {{ 'blocks.lifeChanges.add_habit' | translate }}
  </pl-button>
</form>
